import { IPessoasDependentes } from '../../../types/tables/IPessoasDependentes';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * Serviço para gerenciamento de dependentes com isolamento multi-tenant
 * Relacionamento entre responsáveis e alunos dependentes
 */
export class PessoasDependentesService extends BaseMultiTenantService<IPessoasDependentes> {
     constructor() {
          super(
               'pessoas_dependentes', 
               [],
               'fk_id_organizacao'
          );
     }

     /**
      * Busca dependentes por responsável
      */
     async getByResponsavel(organizationId: number, responsavelId: number) {
          return await this.client
               .from('pessoas_dependentes')
               .select(`
                    *,
                    aluno:pessoas!fk_id_aluno (nome, email, documento_tipo, documento_numero),
                    responsavel:pessoas!fk_id_responsavel (nome, email)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_responsavel', responsavelId);
     }

     /**
      * Busca responsáveis por aluno
      */
     async getByAluno(organizationId: number, alunoId: number) {
          return await this.client
               .from('pessoas_dependentes')
               .select(`
                    *,
                    aluno:pessoas!fk_id_aluno (nome, email, documento_tipo, documento_numero),
                    responsavel:pessoas!fk_id_responsavel (nome, email)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_aluno', alunoId);
     }

     /**
      * Verifica se uma pessoa é dependente de outra
      */
     async isDependente(organizationId: number, alunoId: number, responsavelId: number) {
          const { data } = await this.client
               .from('pessoas_dependentes')
               .select('id')
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_aluno', alunoId)
               .eq('fk_id_responsavel', responsavelId)
               .single();

          return !!data;
     }

     /**
      * Lista todos os alunos de uma organização
      */
     async getTodosAlunos(organizationId: number) {
          return await this.client
               .from('pessoas_dependentes')
               .select(`
                    aluno:pessoas!fk_id_aluno (
                         id, nome, email, documento_tipo, documento_numero,
                         saldos_alunos (saldo_disponivel, limite_diario, limite_semanal)
                    )
               `)
               .eq(this.organizationIdField, organizationId);
     }

     /**
      * Lista todos os responsáveis de uma organização
      */
     async getTodosResponsaveis(organizationId: number) {
          return await this.client
               .from('pessoas_dependentes')
               .select(`
                    responsavel:pessoas!fk_id_responsavel (
                         id, nome, email,
                         saldos_responsaveis (saldo_atual, saldo_bloqueado)
                    )
               `)
               .eq(this.organizationIdField, organizationId);
     }

     /**
      * Conta quantos dependentes um responsável possui
      */
     async countDependentes(organizationId: number, responsavelId: number) {
          const { count } = await this.client
               .from('pessoas_dependentes')
               .select('*', { count: 'exact', head: true })
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_responsavel', responsavelId);

          return count || 0;
     }
}
